import React, { useState } from "react";
import ActionFormatter from "Components/Table/ActionFormatter/ActionFormatter";
import AlertDialog from "Components/AlertDialog/AlertDialog";
import {useDispatch, useSelector} from "react-redux";
import Translator from "Languages/Utility/Translator";
import { changeTableData } from "Stores/actions/ContractActions";
import * as Icons from 'react-bootstrap-icons';

function DeleteContract({ row }) {
    const { tableDataContract } = useSelector((state) => ({
        tableDataContract: state.contract.tableDataContract,
    }));
    const dispatch = useDispatch();
    const [showAlert, setShowAlert] = useState(false);
    const [loading, setLoading] = useState(false);

    const onShowAlert = () => {
        setShowAlert(!showAlert);
    };


    const onDelete = () => {
        const newList = tableDataContract.filter(
            (item) => item.id !== row.id
        );
        dispatch(changeTableData(newList));
        onShowAlert();
    };

    return (
        <>
            <ActionFormatter
                title={<Translator id="hazf" />}
                icon={<Icons.Trash3 size={17} />}
                className="danger-fill"
                onClick={onShowAlert}
            />
            <AlertDialog
                showAlert={showAlert}
                type="alertError"
                onClose={onShowAlert}
                onClickOk={onDelete}
                okTitle={<Translator id="ble_pak_shavad" />}
                cancelTitle={<Translator id="enseraf" />}
                questionText={<Translator id="aya_az_hazf_an_etminan_darid" />}
                loading={loading}
            />
        </>
    );
}

export default DeleteContract;
